// import NavBar from '../navbar/navbar';
import { FloatingLabel, Form, Spinner, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import "../login/authStyles.css";

const keyCodesAllowedForOTP = [
  "8",
  "48",
  "49",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "96",
  "97",
  "98",
  "99",
  "100",
  "101",
  "102",
  "103",
  "104",
  "105",
];

const SignUp = () => {
  const history = useHistory();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [confirmPassword, setConfirmPassword] = useState("");

  const [address, setAddress] = useState("");
  const [logo, setLogo] = useState("");

  const [role, setRole] = useState("");
  const [clientType, setClientType] = useState("");
  const [signupLoading, setSignupLoading] = useState(false);
  const [showSignUp, setShowSignUp] = useState(true);
  const [showSignUpError, setShowSignUpError] = useState(false);
  const [otpTimer, SetOtpTimer] = useState(30);
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("");
  const [passwordNotMatching, setPasswordNotMatching] = useState("");
  const [successModal, setSuccessModal] = useState(false);

  const [otp1, setOtp1] = useState("");
  const [otp2, setOtp2] = useState("");
  const [otp3, setOtp3] = useState("");
  const [otp4, setOtp4] = useState("");
  const [otp5, setOtp5] = useState("");
  const [otp6, setOtp6] = useState("");
  const [otpVerificationLoading, setOtpVerificationLoading] = useState(false);

  useEffect(() => {
    if (otpTimer > 0 && !showSignUp) {
      const intervalID = setInterval(
        () => SetOtpTimer((timer) => timer - 1),
        1000
      );
      return () => {
        clearInterval(intervalID);
      };
    }
  }, [otpTimer, showSignUp]);

  useEffect(() => {
    SetOtpTimer(30);
  }, [showSignUp]);

  const submitHandler = async (event) => {
    event.preventDefault();
    // Checks for password to be added above this line
    if (
      password.length >= 8 &&
      passwordPatternCheck(password) &&
      password === confirmPassword
    ) {
      setShowSignUpError(false);
      setSignupLoading(true);
      const signupRequestBody = {
        name: name,
        email: email,
        phone_number: "+91" + mobileNo, // This needs to be changed later
        username: username,
        password: password,
        role: role,
        client_type: clientType,
      };
      if (address) {
        signupRequestBody.address = address;
      }
      if (logo) {
        signupRequestBody.picture = logo;
      }
      const signUpApi =
        "https://jyxmm1ky78.execute-api.ap-south-1.amazonaws.com/Testing/client/signup";
      const signUpApiConfiguration = {
        method: "POST",
        data: JSON.stringify(signupRequestBody),
        url: signUpApi,
      };

      try {
        const signUpResponseBody = await axios(signUpApiConfiguration);
        if (signUpResponseBody.data.isSuccess) {
          setSignupLoading(false);
          setShowSignUp(false);
        } else {
          setShowSignUpError(
            signUpResponseBody.data.error.message
              ? signUpResponseBody.data.error.message
              : signUpResponseBody.data.error
          );
          setSignupLoading(false);
        }
      } catch (error) {
        setShowSignUpError(error.message || "An error occurred during signup");
        setSignupLoading(false);
      }
    } else if (password !== confirmPassword) {
      setPasswordNotMatching("Passwords not matching");
    } else {
      setPasswordErrorMessage(
        "Password with min 8 characters must contain atleast one capital, small, number and special character."
      );
    }
  };

  const otpFormFocus = (event) => {
    if (keyCodesAllowedForOTP.includes(event.which.toString())) {
      if (["Backspace", "Delete"].includes(event.key)) {
        const tabIndex = event.target.tabIndex;
        console.log("tabIndex", tabIndex);
        if (tabIndex > 0) {
          event.target.form.elements[tabIndex - 1].focus();
        }
      } else {
        const tabIndex = event.target.tabIndex;
        if (tabIndex < 5) {
          event.target.form.elements[tabIndex + 1].focus();
        }
      }
    }
  };

  const otpVerification = async () => {
    setOtpVerificationLoading(true);
    const otpCode = otp1 + otp2 + otp3 + otp4 + otp5 + otp6;
    const otpRequestBody = {
      username: username,
      confirmation_code: otpCode,
    };
    const otpVerificationCongig = {
      url: "https://jyxmm1ky78.execute-api.ap-south-1.amazonaws.com/Testing/client/email/verify",
      method: "post",
      data: JSON.stringify(otpRequestBody),
    };

    try {
      const otpVerificationResponse = await axios(otpVerificationCongig);
      if (otpVerificationResponse.data.isSuccess) {
        setOtpVerificationLoading(false);
        setShowSignUp(true);
        setSuccessModal(true);
      } else {
        setOtpVerificationLoading(false);
        // Error handling: Alert user as no error UI exists in OTP view
        alert("Verification failed. Please check the code and try again.");
      }
    } catch (error) {
      setOtpVerificationLoading(false);
      alert("An error occurred during verification. Please try again.");
    }
  };

  const resendOtp = async () => {
    const resendOTPData = { username: username };
    const resendOTPConfig = {
      method: "POST",
      url: "https://jyxmm1ky78.execute-api.ap-south-1.amazonaws.com/Testing/client/email/resend",
      data: resendOTPData,
    };

    try {
      const resendOtpResponse = await axios(resendOTPConfig);
      if (resendOtpResponse.data.isSuccess) {
        SetOtpTimer(30);
        setOtp1("");
        setOtp2("");
        setOtp3("");
        setOtp4("");
        setOtp5("");
        setOtp6("");
      } else {
        alert("Failed to resend OTP. Please try again.");
      }
    } catch (error) {
      alert("An error occurred while resending OTP.");
    }
  };
  console.log("otpTimer\n", otpTimer);

  const passwordPatternCheck = (passwordInput) => {
    let specialCharCheck = false;
    let capitalLetterCheck = false;
    let smallLetterCheck = false;
    let numericValueCheck = false;

    capitalLetterCheck = passwordInput
      .split("")
      .some(
        (charcode, index) =>
          passwordInput.charCodeAt(index) >= 65 &&
          passwordInput.charCodeAt(index) <= 90
      );
    smallLetterCheck = passwordInput
      .split("")
      .some(
        (charcode, index) =>
          passwordInput.charCodeAt(index) >= 97 &&
          passwordInput.charCodeAt(index) <= 122
      );
    numericValueCheck = passwordInput
      .split("")
      .some(
        (charcode, index) =>
          passwordInput.charCodeAt(index) >= 48 &&
          passwordInput.charCodeAt(index) <= 57
      );
    specialCharCheck = passwordInput
      .split("")
      .some(
        (charcode, index) =>
          (passwordInput.charCodeAt(index) >= 91 &&
            passwordInput.charCodeAt(index) <= 96) ||
          (passwordInput.charCodeAt(index) >= 58 &&
            passwordInput.charCodeAt(index) <= 64) ||
          (passwordInput.charCodeAt(index) >= 33 &&
            passwordInput.charCodeAt(index) <= 47) ||
          (passwordInput.charCodeAt(index) >= 123 &&
            passwordInput.charCodeAt(index) <= 126)
      );

    return (
      numericValueCheck &&
      capitalLetterCheck &&
      smallLetterCheck &&
      specialCharCheck
    );
  };

  const SuccessfullSignUpModal = () => {
    return (
      <Modal
        show={successModal}
        // onHide={() => ()}
        animation={true}
        centered
        contentClassName="modalCard"
        backdrop={"static"}
      >
        <img
          src="https://niroggyan.s3.ap-south-1.amazonaws.com/feedback/modal-tick.svg"
          alt="tick"
        />
        <Modal.Body style={{ border: "none" }}>
          <h1 className="modal-text">{username} successfully registered</h1>
        </Modal.Body>
        <div className="mt-2">
          <button
            className="btn btn-primary"
            variant="secondary"
            onClick={() => {
              setSuccessModal(false);
              history.replace("/signup");
            }}
          >
            Sign Up again
          </button>
          <button
            className="btn btn-primary mx-3"
            variant="secondary"
            onClick={() => {
              history.replace("/login");
            }}
          >
            Continue to login
          </button>
        </div>
      </Modal>
    );
  };

  return (
    <div className='auth-container'>
      <div className='auth-bg-circle circle-1'></div>
      <div className='auth-bg-circle circle-2'></div>

      <div className='auth-wrapper'>
        {/* Left Visual Side - Hidden on mobile */}
        <div className='auth-visual'>
          <img
            src='https://niroggyan.s3.ap-south-1.amazonaws.com/pdftosrportal/loginLandingImage.svg'
            alt='Niroggyan Dashboard'
          />
          <div className='auth-visual-text'>
            <h3>Join Niroggyan</h3>
            <p>Create an account to start managing your lab reports and analytics.</p>
          </div>
        </div>

        {/* Right Form Side */}
        <div className='auth-form-container'>
          <img
            src='https://niroggyan.s3.ap-south-1.amazonaws.com/new-billing-dashboard-files/logos/niroggyan-logo.svg'
            alt="Niroggyan"
            className="auth-logo"
            onClick={() => history.push('/')}
          />

          <div className='auth-header'>
            <h2 className='auth-title'>Create Account</h2>
            <p className='auth-subtitle'>
              {showSignUp ? 'Fill in the details below to get started.' : 'Verify your email to continue.'}
            </p>
          </div>

          {/* Sign Up Form */}
          {showSignUp && (
            <Form
              id="signup-body"
              onSubmit={submitHandler}
              autoComplete="off"
              className='auth-form'
            >
              <div className="row g-3">
                <div className="col-md-6">
                  <FloatingLabel controlId="name" label="Name">
                    <Form.Control
                      onChange={(e) => setName(e.target.value)}
                      required
                      type="text"
                      placeholder="Name"
                      value={name}
                    />
                  </FloatingLabel>
                </div>
                <div className="col-md-6">
                  <FloatingLabel controlId="email" label="Email Address">
                    <Form.Control
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      type="email"
                      placeholder="name@example.com"
                      value={email}
                    />
                  </FloatingLabel>
                </div>

                <div className="col-md-6">
                  <FloatingLabel controlId="mobile" label="Mobile Number">
                    <Form.Control
                      type="tel"
                      placeholder="Mobile"
                      inputMode="numeric"
                      maxLength="10"
                      title="10 digit Mobile Number"
                      onChange={(e) => setMobileNo(e.target.value)}
                      value={mobileNo}
                    />
                  </FloatingLabel>
                </div>
                <div className="col-md-6">
                  <FloatingLabel controlId="username" label="Username">
                    <Form.Control
                      required
                      type="text"
                      autoComplete="off"
                      placeholder="Username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </FloatingLabel>
                </div>

                <div className="col-md-6">
                  <FloatingLabel controlId="password" label="Password">
                    <Form.Control
                      required
                      type="password"
                      autoComplete="new-password"
                      placeholder="Password"
                      onChange={(e) => {
                        setPassword(e.target.value);
                        setPasswordErrorMessage("");
                      }}
                      value={password}
                    />
                  </FloatingLabel>
                  {passwordErrorMessage && <p className="text-danger small mt-1">* {passwordErrorMessage}</p>}
                </div>
                <div className="col-md-6">
                  <FloatingLabel controlId="confirmPassword" label="Confirm Password">
                    <Form.Control
                      required
                      type="password"
                      placeholder="Confirm"
                      onChange={(e) => {
                        setConfirmPassword(e.target.value);
                        setPasswordNotMatching("");
                      }}
                      value={confirmPassword}
                    />
                  </FloatingLabel>
                  {passwordNotMatching && <p className="text-danger small mt-1">* {passwordNotMatching}</p>}
                </div>

                {/* Additional Fields */}
                <div className="col-md-6">
                  <FloatingLabel controlId="address" label="Address">
                    <Form.Control
                      type="text"
                      placeholder="Address"
                      onChange={(e) => setAddress(e.target.value)}
                      value={address}
                    />
                  </FloatingLabel>
                </div>
                <div className="col-md-6">
                  <FloatingLabel controlId="logo" label="Logo URL">
                    <Form.Control
                      type="text"
                      placeholder="Logo"
                      onChange={(e) => setLogo(e.target.value)}
                      value={logo}
                    />
                  </FloatingLabel>
                </div>

                <div className="col-md-6">
                  <FloatingLabel controlId="role" label="Role">
                    <Form.Select
                      value={role}
                      onChange={(e) => setRole(e.target.value)}
                    >
                      <option value="" disabled>Select Role</option>
                      <option value="admin">Admin</option>
                      <option value="user">User</option>
                    </Form.Select>
                  </FloatingLabel>
                </div>
                <div className="col-md-6">
                  <FloatingLabel controlId="clientType" label="Client Type">
                    <Form.Select
                      value={clientType}
                      onChange={(e) => setClientType(e.target.value)}
                    >
                      <option value="" disabled>Select Type</option>
                      <option value="lab">Lab</option>
                      <option value="lis">LIS</option>
                      <option value="admin">Admin</option>
                    </Form.Select>
                  </FloatingLabel>
                </div>
              </div>

              <div className="mt-4">
                <button
                  type="submit"
                  className="auth-btn"
                  disabled={signupLoading}
                >
                  {signupLoading ? (
                    <>Signing Up <Spinner size="sm" animation="border" className="ms-2" /></>
                  ) : (
                    "Create Account"
                  )}
                </button>

                {showSignUpError && (
                  <p className="text-danger mt-2 text-center">* {showSignUpError}</p>
                )}
              </div>
            </Form>
          )}

          {/* OTP Verification Form */}
          {!showSignUp && (
            <div className="auth-form">
              <p className="text-center mb-4 text-muted">A verification code has been sent to your email.</p>
              <Form
                id="otp-form"
                className="d-flex justify-content-center gap-2 mb-4"
                onSubmit={(event) => {
                  event.preventDefault();
                  otpVerification();
                }}
              >
                {[otp1, otp2, otp3, otp4, otp5, otp6].map((digit, idx) => (
                  <Form.Control
                    key={idx}
                    style={{
                      textAlign: "center",
                      height: "50px",
                      width: "45px",
                      fontSize: "1.2rem",
                      fontWeight: "bold"
                    }}
                    tabIndex={idx}
                    maxLength={1}
                    pattern="[0-9]*"
                    inputMode="numeric"
                    onKeyUp={(event) => otpFormFocus(event)}
                    onChange={(event) => {
                      const setters = [setOtp1, setOtp2, setOtp3, setOtp4, setOtp5, setOtp6];
                      setters[idx](event.target.value);
                    }}
                    value={digit}
                  />
                ))}
              </Form>

              <button
                onClick={() => otpVerification()}
                className="auth-btn mb-3"
                disabled={
                  otpVerificationLoading ||
                  [otp1, otp2, otp3, otp4, otp5, otp6].includes("")
                }
              >
                {otpVerificationLoading ? <Spinner size="sm" animation="border" /> : "Verify Email"}
              </button>

              <div className="text-center">
                <button
                  disabled={otpTimer !== 0}
                  onClick={resendOtp}
                  className={`auth-link ${otpTimer !== 0 ? 'text-muted' : ''}`}
                  style={{ fontSize: '0.9rem' }}
                >
                  Resend Verification Code
                </button>
                {otpTimer !== 0 && (
                  <span className="d-block text-muted small mt-1">
                    Resend available in {otpTimer}s
                  </span>
                )}
              </div>
            </div>
          )}

          <div className='auth-footer'>
            Already have an account?{' '}
            <button
              className='auth-link'
              onClick={() => history.push('/login')}
            >
              Log In
            </button>
          </div>

        </div>
      </div>
      <SuccessfullSignUpModal />
    </div>
  );
};

export default SignUp;
